import { DefaultState } from '@src/redux/types'

import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ALL_FILTER,
  CONFERENCE_ARTICLE,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_LIST,
  CONFERENCE_ARTICLE_PROOF,
  CONFERENCE_ARTICLE_STEP,
  CONFERENCE_CATEGORY_ALL,
  CONFERENCE_CREATE,
  CONFERENCE_MAGAZINE_ARTICLE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [CONFERENCE]: DefaultState<`${typeof API.CONFERENCE}{id}`, 'get'>
  [CONFERENCE_ARTICLE]: DefaultState<`${typeof API.CONFERENCE_ARTICLE}{id}`, 'get'>
  [CONFERENCE_ARTICLE_LIST]: DefaultState<`${typeof API.CONFERENCE_ARTICLE_LIST}`, 'get'>
  [CONFERENCE_CREATE]: DefaultState<`${typeof API.CONFERENCE}`, 'post'>
  [CONFERENCE_ARTICLE_STEP]: DefaultState<`${typeof API.CONFERENCE_ARTICLE_STEP}`, 'post'>
  [CONFERENCE_ARTICLE_PROOF]: DefaultState<`${typeof API.CONFERENCE_ARTICLE_PROOF}`, 'post'>
  [CONFERENCE_ALL]: DefaultState<`${typeof API.CONFERENCE_ALL}`, 'get'>
  [CONFERENCE_ALL_FILTER]: DefaultState<`${typeof API.CONFERENCE_ALL_FILTER}`, 'get'>
  [CONFERENCE_ARTICLE_ALL]: DefaultState<`${typeof API.CONFERENCE_ARTICLE_ALL}`, 'get'>
  [CONFERENCE_MAGAZINE_ARTICLE]: DefaultState<`${typeof API.CONFERENCE_MAGAZINE_ARTICLE}`, 'get'>
  [CONFERENCE_CATEGORY_ALL]: DefaultState<`${typeof API.CONFERENCE_CATEGORY_ALL}`, 'get'>
} = () => ({
  [CONFERENCE]: defaultState(),
  [CONFERENCE_ARTICLE]: defaultState(),
  [CONFERENCE_ARTICLE_LIST]: defaultState(),
  [CONFERENCE_CREATE]: defaultState(),
  [CONFERENCE_ARTICLE_STEP]: defaultState(),
  [CONFERENCE_ARTICLE_PROOF]: defaultState(),
  [CONFERENCE_ALL]: defaultState(),
  [CONFERENCE_ALL_FILTER]: defaultState(),
  [CONFERENCE_ARTICLE_ALL]: defaultState(),
  [CONFERENCE_MAGAZINE_ARTICLE]: defaultState(),
  [CONFERENCE_CATEGORY_ALL]: defaultState(),
})
